import { Coach, RegistrationStep } from "../interfaces/Coach";

/**
 * Resolves the registration step from the new schema when available, while
 * preserving a temporary fallback to legacy coach.status values during the
 * migration period.
 */
export const getEffectiveRegistrationStep = (coach: Coach | null | undefined): RegistrationStep | undefined => {
    if (!coach) return undefined;

    const paymentCompleted = Boolean(coach.registration?.paymentCompletedAt);
    const emailVerified = Boolean(coach.verifiedEmail || coach.registration?.emailVerifiedAt);

    // Once payment has succeeded, unverified coaches should continue through the
    // dedicated email verification step even if an older write marked them complete.
    if (paymentCompleted && !emailVerified) {
        console.log("Coach has completed payment but email is not verified. Returning email_verification step.");
        return "email_verification";
    }

    // registration.step is the authoritative workflow field for the new schema.
    if (coach.registration?.step) return coach.registration.step;

    // Legacy status mappings remain as a temporary compatibility fallback while
    // old coach documents are migrated to the new registration.step model.
    switch (coach.status as string | undefined) {
        case "pending":
        case "pending_email":
            // Preserve the onboarding step in the schema, but skip it for legacy records too.
            return "payment";
        case "pending_payment":
            return "payment";
        case "pending_email_verification":
            return "email_verification";
        case "active":
        case "complete":
            return "complete";
        case "deactivated":
        case "suspended":
            return undefined;
        default:
            return "payment";
    }
};
